(function() {
    // a11y remediation

    // Added a class to the body to indicate that accessibility fixes are enabled and to allow for a11y-specific CSS rules to be applied (DO NOT REMOVE).

    document.body.classList.add('a11y');

    if (!document.body.classList.contains('a11y')) {
        return;
    } else {
        console.log('a11y enabled!');
    }

    /* ==========================================================================
    = Header & Other Global Accessibility Fixes 
    ========================================================================== */

    /* = Fix 3: Added sufficient alt text for dynamically generated header badges
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        var bbbImg = document.querySelector('.c-bbb-wrap img');

        if (bbbImg) {
            bbbImg.alt = 'AlarmSystemStore.com BBB Accredited Business with an A+ rating';
        }

        var resellerImg = document.querySelector('.c-reseller-ratings img');

        if (resellerImg) {
            resellerImg.alt = 'AlarmSystemStore.com is rated 5 stars on ResellerRatings';
        }
    });

    /* = Fix 4: Added discernible text for the mobile search icon
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const searchLink = document.querySelector('.mobile-tools-right a[href="/search"]');

        if (searchLink && !searchLink.querySelector('.visually-hidden')) {
            const span = document.createElement('span');
            span.className = 'visually-hidden';
            span.textContent = 'Search';
            searchLink.appendChild(span);
        }
    });

    /* = Fixes 7, 8 & 14: Added keyboard functionality to the cart dropdown
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const cartTarget = document.getElementById('cart-target');
        const cartLink = cartTarget?.querySelector('a.cart.dropdown-toggle');
        const cartMenu = cartTarget?.querySelector('#cart-info');

        if (!cartLink || !cartMenu) return;

        cartLink.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
        });

        cartLink.setAttribute('aria-haspopup', 'true');
        cartLink.setAttribute('aria-controls', 'cart-info');
        cartLink.setAttribute('aria-expanded', 'false');

        function isMenuVisible() {
            return window.getComputedStyle(cartMenu).display !== 'none';
        }

        function openMenu() {
            cartMenu.style.display = 'block';
            cartLink.setAttribute('aria-expanded', 'true');
            bindFocusTrap();
        }

        function closeMenu() {
            cartMenu.style.display = 'none';
            cartLink.setAttribute('aria-expanded', 'false');
            cartLink.focus();
        }

        function bindFocusTrap() {
            cartMenu.onkeydown = (e) => {
                if (!isMenuVisible()) return;

                const focusable = cartMenu.querySelectorAll(
                    'a[href], button, [tabindex]:not([tabindex="-1"])'
                );

                if (!focusable.length) return;

                const first = focusable[0];
                const last = focusable[focusable.length - 1];

                if (e.key === 'Tab') {
                    if (e.shiftKey && document.activeElement === first) {
                        e.preventDefault();
                        last.focus();
                    } else if (!e.shiftKey && document.activeElement === last) {
                        e.preventDefault();
                        first.focus();
                    }
                }
            };
        }

        cartLink.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();

                if (isMenuVisible()) {
                    closeMenu();
                } else {
                    openMenu();
                }
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') return;
            if (!isMenuVisible()) return;

            closeMenu();
        });

        cartLink.addEventListener('mouseenter', () => {
            cartLink.setAttribute('aria-expanded', 'true');
        });

        cartLink.addEventListener('mouseleave', () => {
            if (!isMenuVisible()) {
                cartLink.setAttribute('aria-expanded', 'false');
            }
        });
    });

    /* = Fix 15: Added a descriptive heading to the cart dropdown
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const cartTarget = document.getElementById('cart-target');
        if (!cartTarget) return;

        const cartMenu = cartTarget.querySelector('#cart-info');
        if (!cartMenu) return;

        let cartHeading = cartMenu.querySelector('.cart-heading');

        if (!cartHeading) {
            cartHeading = document.createElement('h2');
            cartHeading.className = 'cart-heading';
            cartHeading.textContent = 'Shopping Cart';
            cartMenu.insertBefore(cartHeading, cartMenu.firstChild);
        }

        const isOpen = () => {
            const styleOpen = cartMenu.style.display === 'block';
            const classOpen =
                cartMenu.classList.contains('open') ||
                cartMenu.classList.contains('show') ||
                cartMenu.classList.contains('active');

            return styleOpen || classOpen;
        };

        const syncHeadingVisibility = () => {
            cartHeading.style.display = isOpen() ? 'block' : 'none';
        };

        cartTarget.addEventListener('mouseenter', syncHeadingVisibility);
        cartTarget.addEventListener('mouseleave', syncHeadingVisibility);

        const observer = new MutationObserver(syncHeadingVisibility);
        observer.observe(cartMenu, {
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        syncHeadingVisibility();
    });

    /* = Fix 18: Added a aria-labels to footer contact links
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        var phoneLink = document.querySelector('.footer_info_inner .support-text[href^="tel:"]');

        if (phoneLink) {
            phoneLink.setAttribute('aria-label', 'Call Alarm System Store at 888-811-0727');

            var phoneIcon = phoneLink.querySelector('.fa-phone');
            if (phoneIcon) {
                phoneIcon.setAttribute('aria-hidden', 'true');
            }
        }

        var emailLink = document.querySelector('.footer_info_inner .support-text[href="/pages/email-us"]');

        if (emailLink) {
            emailLink.setAttribute('aria-label', 'Email Alarm System Store');

            var emailIcon = emailLink.querySelector('.fa-envelope');
            if (emailIcon) {
                emailIcon.setAttribute('aria-hidden', 'true');
            }
        }
    });

    /* = Fix 22: Added a title to the Google Merchant Center iFrame
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const wrapper = document.getElementById('google-merchantwidget-iframe-wrapper');
        if (!wrapper) return;

        const applyTitle = (frame) => {
            if (!frame.hasAttribute('title')) {
                frame.setAttribute('title', 'Google Merchant Center embedded panel');
            }
        };

        const observer = new MutationObserver((mutations) => {
            const frame = wrapper.querySelector('iframe#merchantwidgetiframe');
            if (frame) {
                const src = frame.getAttribute('src') || '';
                if (src.includes('google.com/shopping/merchantverse')) {
                    applyTitle(frame);
                }
            }
        });

        observer.observe(wrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['src', 'style', 'title']
        });

        const initialFrame = wrapper.querySelector('iframe#merchantwidgetiframe');
        if (initialFrame) applyTitle(initialFrame);
    });

    /* = Fix 25: Added a "Skip to main content" button
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const skip = document.querySelector('.skip-to-content');
        if (!skip) return;

        skip.addEventListener('click', () => {
            const main = document.getElementById('main-content');
            if (main) {
                main.setAttribute('tabindex', '-1');
                main.focus();
            }
        });
    });

    /* = Fixes 29 & 135: Added aria-labels to "View products" buttons
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        function applyAriaLabels() {
            const buttons = document.querySelectorAll('.snize-view-product-button');

            buttons.forEach(btn => {
                if (!btn.hasAttribute('aria-label')) {
                    const titleEl = btn.closest('.snize-item')?.querySelector('.snize-title');
                    const productTitle = titleEl ? titleEl.textContent.trim() : 'product';
                    btn.setAttribute('aria-label', `View product: ${productTitle}`);
                }
            });
        }

        applyAriaLabels();

        const observer = new MutationObserver(applyAriaLabels);
        observer.observe(document.body, { childList: true, subtree: true });
    });

    /* = Fix 31: Improved aria-labels for prev/next buttons in slideshow
    -------------------------------------------------------------- */

    (function () {
        function patchFlexNav() {
            var prev = document.querySelector('#home-slideshow .flex-direction-nav .flex-prev');
            var next = document.querySelector('#home-slideshow .flex-direction-nav .flex-next');

            console.log('prev found?', !!prev);
            console.log('next found?', !!next);

            if (prev) {
                prev.setAttribute('aria-label', 'Previous slide');
                var prevIcon = prev.querySelector('.fa-chevron-left');
                if (prevIcon) prevIcon.setAttribute('aria-hidden', 'true');
            }

            if (next) {
                next.setAttribute('aria-label', 'Next slide');
                var nextIcon = next.querySelector('.fa-chevron-right');
                if (nextIcon) nextIcon.setAttribute('aria-hidden', 'true');
            }
        }

        window.addEventListener('load', function () {
            patchFlexNav();
        });

        var attempts = 0;
        var timer = setInterval(function () {
            attempts++;
            patchFlexNav();
            if (attempts >= 10) clearInterval(timer);
        }, 500);
    })();

    /* = Fix 32: Added the appropriate ARIA attributes to slideshow pagers
    -------------------------------------------------------------- */

    (function() {
        var selector = 'ol.flex-control-nav.flex-control-paging';

        function updateAria(nav) {
            var dots = nav.querySelectorAll('li > a');
            var total = dots.length;

            dots.forEach(function(dot, index) {
                var isActive = dot.classList.contains('flex-active');

                dot.setAttribute('aria-label', 'Slide ' + (index + 1) + ' of ' + total);

                if (isActive) {
                    dot.setAttribute('aria-current', 'true');
                } else {
                    dot.removeAttribute('aria-current');
                }
            });
        }

        function observeNav(nav) {
            updateAria(nav);

            var observer = new MutationObserver(function() {
                updateAria(nav);
            });

            observer.observe(nav, {
                attributes: true,
                subtree: true,
                attributeFilter: ['class']
            });
        }

        function init() {
            document.querySelectorAll(selector).forEach(observeNav);

            var rootObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                    if (!(node instanceof Element)) return;

                    if (node.matches(selector)) {
                        observeNav(node);
                    } else {
                        node.querySelectorAll && node.querySelectorAll(selector).forEach(observeNav);
                    }
                    });
                });
            });

            rootObserver.observe(document.body, { childList: true, subtree: true });
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
    })();

    /* ==========================================================================
    = Collections Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 42: Changed category controls to <button> tags
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.category-trigger').forEach(function (btn) {
            var target = document.getElementById(btn.getAttribute('aria-controls'));

            btn.addEventListener('click', function () {
                var expanded = btn.getAttribute('aria-expanded') === 'true';
                btn.setAttribute('aria-expanded', String(!expanded));
                target.classList.toggle('hidden', expanded);
                btn.focus();
            });
        });
    });

    /* = Fix 47: Added ARIA attributes to the collection page title and main content
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        if (window.location.pathname !== '/collections/all') return;

        const h1 = document.querySelector('.collection-description h1');
        const main = document.querySelector('main, #main-content, .wrapper');

        if (!h1 || !main) return;

        if (!h1.id) h1.id = 'collection-page-title';

        main.setAttribute('aria-labelledby', h1.id);
    });

    /* ==========================================================================
    = Single Product Accessibility Fixes 
    ========================================================================== */

    /* = Fix 59: Added keyboard functionality for the quantity input
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const input = document.querySelector('#quantity');
        const live = document.querySelector('#qty-live');
        const down = document.querySelector('.qty-down');
        const up = document.querySelector('.qty-up');

        if (!input || !live || !down || !up) return;

        function bindQtyControl(el, delta) {
            live.textContent = `Quantity ${Number(input.value)}`;

            el.addEventListener('click', (e) => {
                e.preventDefault();

                const current = Number(input.value);
                const next = Math.max(1, current + delta);
                live.textContent = `Quantity ${next}`;
            });

            el.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();

                    const current = Number(input.value);
                    const next = Math.max(1, current + delta);
                    input.value = next;

                    live.textContent = `Quantity ${next}`;
                }
            });
        }

        bindQtyControl(down, -1);
        bindQtyControl(up, +1);
    });

    /* ==========================================================================
    = Cart Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 105: Added a tiny JS patch to guarantee VoiceOver/Safari announcement for calculate shipping error message
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const feedback = document.getElementById('shipping-rates-feedback');

        if (feedback && feedback.classList.contains('error')) {
            feedback.setAttribute('tabindex', '-1');
            feedback.focus();
        }
    });

    /* ==========================================================================
    = Search Page Accessibility Fixes 
    ========================================================================== */

    /* = Fix 128: Reordered the dropdown and view mode controls for better accessibility
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const mq = window.matchMedia('(min-width: 821px)');

        function reorder() {
            if (!mq.matches) return;

            const panel = document.querySelector('.snize-main-panel');
            if (!panel) return;

            const dropdown = panel.querySelector('.snize-main-panel-dropdown');
            const viewMode = panel.querySelector('.snize-main-panel-view-mode');

            if (dropdown && viewMode && dropdown.nextElementSibling !== viewMode) {
                panel.insertBefore(dropdown, viewMode);
            }
        }

        function persistentFix() {
            reorder();
            requestAnimationFrame(persistentFix);
        }

        persistentFix();
    });

    /* = Fixes 132-134: Added ARIA attributes to the Snize filters dropdowns
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        function initDropdown(btn, content, wrapper) {
            wrapper.removeAttribute('aria-expanded');
            wrapper.removeAttribute('aria-labelledby');
            wrapper.removeAttribute('role');

            if (!content.id) {
                content.id = (wrapper.id || 'snize_filters_dropdown') + '_content';
            }

            btn.setAttribute('role', 'button');
            btn.setAttribute('tabindex', '0');
            btn.setAttribute('aria-controls', content.id);

            const isVisible = content.style.display !== 'none';
            btn.setAttribute('aria-expanded', String(isVisible));
        }

        function toggleDropdown(btn) {
            if (!btn) return;
            const wrapper = btn.closest('.snize-filters-dropdown');
            if (!wrapper) return;

            const content = wrapper.querySelector('.snize-filters-dropdown-content');
            if (!content) return;

            const expanded = btn.getAttribute('aria-expanded') === 'true';
            const newState = !expanded;

            btn.setAttribute('aria-expanded', String(newState));
            content.style.display = newState ? 'block' : 'none';
        }

        function initDropdowns() {
            document.querySelectorAll('.snize-filters-dropdown').forEach(function (wrapper) {
                const btn = wrapper.querySelector('.snize-filters-dropdown-title');
                const content = wrapper.querySelector('.snize-filters-dropdown-content');
                if (!btn || !content) return;

                initDropdown(btn, content, wrapper);
            });
        }

        initDropdowns();

        const observer = new MutationObserver(function () {
            initDropdowns();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.snize-filters-dropdown-title');
            if (btn) {
                toggleDropdown(btn);

                document.querySelectorAll('.snize-filters-dropdown-title.active')
                    .forEach(el => el.classList.remove('active'));
                btn.classList.add('active');
            }
        });

        function toggleSidebarBlock(btn) {
            if (!btn) return;
            const wrapper = btn.closest('.snize-product-filters-block');
            if (!wrapper) return;

            const content =
                wrapper.querySelector('.snize-product-filters-content') ||
                wrapper.querySelector('.snize-product-filters-list') ||
                wrapper.querySelector('.snize-price-range') ||
                wrapper.querySelector('.snize-range-slider');

            if (!content) return;

            const expanded = btn.getAttribute('aria-expanded') === 'true';
            const newState = !expanded;

            btn.setAttribute('aria-expanded', String(newState));
            btn.classList.toggle('open', newState);
            content.style.display = newState ? 'block' : 'none';
        }

        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.snize-product-filters-title');
            if (btn) {
                toggleSidebarBlock(btn);
            }
        });

        function getDropdownItems(panel) {
            return panel.querySelectorAll(
                'input[type="checkbox"], input[type="radio"], input[type="number"], .pointer.low, .pointer.high, [tabindex]:not([tabindex="-1"])'
            );
        }

        function focusFirstItem(panel) {
            const items = getDropdownItems(panel);
            if (items.length) items[0].focus();
        }

        function cycleItems(e, panel) {
            const items = getDropdownItems(panel);
            const index = Array.prototype.indexOf.call(items, document.activeElement);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const next = items[index + 1] || items[0];
                next.focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prev = items[index - 1] || items[items.length - 1];
                prev.focus();
            }
        }

        document.addEventListener('keydown', function (e) {
            const dropdownTrigger = e.target.closest('.snize-filters-dropdown-title');
            const dropdownWrapper = e.target.closest('.snize-filters-dropdown');
            const dropdownPanel = dropdownWrapper
                ? dropdownWrapper.querySelector('.snize-filters-dropdown-content')
                : null;

            const sidebarTrigger = e.target.closest('.snize-product-filters-title');

            const sidebarWrapper = e.target.closest('.snize-product-filters-block');
            const sidebarPanel = sidebarWrapper
                ? (
                    sidebarWrapper.querySelector('.snize-product-filters-content') ||
                    sidebarWrapper.querySelector('.snize-product-filters-list') ||
                    sidebarWrapper.querySelector('.snize-price-range') ||
                    sidebarWrapper.querySelector('.snize-range-slider')
                )
                : null;


            if (dropdownTrigger && e.key === ' ') {
                e.preventDefault();
                document.querySelectorAll('.snize-filters-dropdown-title.active')
                    .forEach(el => el.classList.remove('active'));
                dropdownTrigger.classList.add('active');
            }

            if (e.key === 'Enter' || e.key === ' ') {
                if (dropdownTrigger) {
                    e.preventDefault();
                    toggleDropdown(dropdownTrigger);
                    return;
                }
                if (sidebarTrigger) {
                    e.preventDefault();
                    toggleSidebarBlock(sidebarTrigger);
                    return;
                }
            }

            if (dropdownTrigger && e.key === 'ArrowDown') {
                e.preventDefault();
                const expanded = dropdownTrigger.getAttribute('aria-expanded') === 'true';

                document.querySelectorAll('.snize-filters-dropdown-title.active')
                    .forEach(el => el.classList.remove('active'));
                dropdownTrigger.classList.add('active');

                if (!expanded) {
                    toggleDropdown(dropdownTrigger);
                    dropdownTrigger.setAttribute('aria-expanded', 'true');
                }
                if (dropdownPanel) focusFirstItem(dropdownPanel);
                return;
            }

            if (sidebarTrigger && e.key === 'ArrowDown') {
                e.preventDefault();
                const expanded = sidebarTrigger.getAttribute('aria-expanded') === 'true';

                if (!expanded) {
                    toggleSidebarBlock(sidebarTrigger);
                }
                if (sidebarPanel) focusFirstItem(sidebarPanel);
                return;
            }

            if (dropdownTrigger && e.key === 'Escape') {
                e.preventDefault();
                toggleDropdown(dropdownTrigger);
                dropdownTrigger.focus();
                return;
            }

            if (sidebarTrigger && e.key === 'Escape') {
                e.preventDefault();
                toggleSidebarBlock(sidebarTrigger);
                sidebarTrigger.focus();
                return;
            }

            if (dropdownPanel && e.key === 'Escape') {
                e.preventDefault();
                const trigger = dropdownWrapper.querySelector('.snize-filters-dropdown-title');
                toggleDropdown(trigger);
                if (trigger) trigger.focus();
                return;
            }

            if (sidebarPanel && e.key === 'Escape') {
                e.preventDefault();
                const trigger = sidebarWrapper.querySelector('.snize-product-filters-title');
                toggleSidebarBlock(trigger);
                if (trigger) trigger.focus();
                return;
            }

            if (dropdownPanel && e.key === 'Tab') {
                const items = getDropdownItems(dropdownPanel);
                const last = items[items.length - 1];

                if (document.activeElement === last && !e.shiftKey) {
                    const trigger = dropdownWrapper.querySelector('.snize-filters-dropdown-title');
                    toggleDropdown(trigger);
                    trigger.setAttribute('aria-expanded', 'false');
                }
            }

            if (dropdownPanel && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
                e.preventDefault();
                cycleItems(e, dropdownPanel);
                return;
            }

            if (sidebarPanel && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
                e.preventDefault();
                cycleItems(e, sidebarPanel);
                return;
            }
        });
    });

    /* = Fix 136: Added ARIA attributes to disabled pagination controls 
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        function fixDisabledPagination() {
            const disabledControls = document.querySelectorAll(
            '.snize-pagination-prev.disabled, .snize-pagination-next.disabled'
            );

            disabledControls.forEach(function (el) {
                el.removeAttribute('aria-hidden');
                el.setAttribute('aria-disabled', 'true');
                el.setAttribute('tabindex', '-1');
                el.setAttribute('role', 'button');

                const isPrev = el.classList.contains('snize-pagination-prev');
                const label = isPrev ? 'Previous page' : 'Next page';
                el.setAttribute('aria-label', label);

                if (!el.querySelector('[aria-hidden="true"]')) {
                    const glyph = el.textContent.trim();
                    el.innerHTML = `<span class="disabled-glyph" aria-hidden="true">${glyph}</span>`;
                }
            });
        }

        fixDisabledPagination();

        const observer = new MutationObserver(() => {
            fixDisabledPagination();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    /* = Fix 137: Added ARIA attributes to the search results page title and main content
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        if (!window.location.pathname.includes('/pages/search-results-page')) return;

        const titleInterval = setInterval(() => {
            const h1 = document.querySelector('h1.page-title');
            const main = document.querySelector('main, #main-content');

            if (!h1 || !main) return;

            clearInterval(titleInterval);

            if (!h1.id) h1.id = 'search-page-title';
            main.setAttribute('aria-labelledby', h1.id);
        }, 50);

        const applyPaginationA11y = () => {
            const pagination = document.querySelector('.snize-pagination ul');
            if (!pagination) return;

            const links = pagination.querySelectorAll('a');

            links.forEach(link => {
            const text = link.textContent.trim();

            if (text === '...') return;

            const pageNum = parseInt(text, 10);
            if (isNaN(pageNum)) return;

            if (!link.hasAttribute('aria-label')) {
                link.setAttribute('aria-label', `Page ${pageNum}`);
            }

            if (link.classList.contains('active')) {
                link.setAttribute('aria-current', 'page');
                link.setAttribute('aria-label', `Page ${pageNum}, current page`);
            }
            });
        };

        applyPaginationA11y();

        const observer = new MutationObserver(() => {
            applyPaginationA11y();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
})();